import m from 'mithril';
import './app.scss';
import { InitialConfigurationData as InitialConfigurationData } from './Models';
import { AppComponents , setupAppComponents} from './app_common_setup';
import { Fsm } from 'little-fsm';
import { appRootDesktopFsmBuilder, DesktopManifiest, HotelAndRoomSelectionContext } from './states/app_desktop_root';
import { buildRoomSelectionPresenter } from './presenters/desktop/RoomSelectionPresenter';
import { buildGuestFormPresenter } from './presenters/desktop/GuestFormPresenter';

declare global {
    interface Window {
        globalLanguageConfig: any;
    }
}

setupAppComponents("app", (appComponents:AppComponents) => {
    let dataSource = appComponents.dataSource;
    dataSource.authentication(Number(appComponents.branding.agentId), appComponents.branding.channel, "").then(result => {
        if(result.accessToken != null){
            dataSource.fetchInitialConfigurationData(result).then(initialConfigData => {
                initAppUI(appComponents, initialConfigData);
            });
        }
    })
});

function initAppUI(appComponents:AppComponents, initialConfigData:InitialConfigurationData) {
    console.log(initialConfigData)

    let appRootElement = appComponents.rootElement;
    const hotelId = appRootElement.getAttribute("data-hotel-id");
    console.log("Curent hotel id {}", hotelId);

    let messageProvider = appComponents.messageProvider;

    let fsm:Fsm<DesktopManifiest> = appRootDesktopFsmBuilder();
    handleRoutingWithHistoryAPI(fsm);

    if(window.globalLanguageConfig) {
        window.globalLanguageConfig.subscribeChange((lang:string) => {            
            messageProvider.setCurrentLang(lang);
            console.log("Lang changed detected!");
            m.redraw();
        });
    }


    
    fsm.init('room_selection', new HotelAndRoomSelectionContext(undefined, undefined, [], null));

    let roomSelectionPresenter = buildRoomSelectionPresenter(fsm.subFsm('room_selection'), appComponents, hotelId!); 
    let guestFormPresenter = buildGuestFormPresenter(fsm.subFsm('guest_form'), appComponents); 

    m.mount(appComponents.rootElement, {
        view: function() {
            let currState = fsm.getCurrentState();

            if(currState == 'room_selection') {
                return roomSelectionPresenter.render();
            } else if(currState == 'guest_form') {
                return guestFormPresenter.render();
            } else {
                return m("div", `No screen for the given state ${currState}`);
            }
        }
    });
}

function handleRoutingWithHistoryAPI(fsm:Fsm<any>) {
    fsm.setStateChangeEffect((oldState, newState, eventName) => {
        console.info(`State changed from ${oldState?.key} to ${newState?.key}`);

        if(eventName != 'back') {
            if(oldState) {            
                window.history.pushState(newState, "", `?state=${newState.key}`);
                console.log(`Pushed state ${newState.key}`)
            } else {    
                window.history.pushState(newState, "", `?state=${newState.key}`)
                console.log(`Replaced state with ${newState.key}`)
            } 
        } else {
            console.log(`Did not push state ${newState.key} to history since back is not allowed`)
        }               
    });

    window.addEventListener('popstate', (event) => {
        console.debug("handling pop state event: ", event);
        console.debug("location.href: ", location.href);
        console.debug("history.state: ", history.state);

        let currState = fsm.getCurrentState();
        fsm.processSubstateEvent(currState, 'back', {});

        m.redraw();
    });
}
